import { render, staticRenderFns } from "./majorDomoRecommend.vue?vue&type=template&id=6d6a9dde&scoped=true&"
import script from "./majorDomoRecommend.vue?vue&type=script&lang=js&"
export * from "./majorDomoRecommend.vue?vue&type=script&lang=js&"
import style0 from "./majorDomoRecommend.vue?vue&type=style&index=0&id=6d6a9dde&lang=stylus&scoped=true&"
import style1 from "./majorDomoRecommend.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6a9dde",
  null
  
)

export default component.exports